module.exports = __webpack_public_path__ + "img/ring_r_c_0_1.7eb164d3.png";